"use client";
import React, { useCallback } from "react";

import { useApp } from "@/lib/hooks/useAppointment";
import { useLocale } from "@/lib/i18n";
import ResponsiveDialog from "../ResponsiveDialog";
import { BookingOverlayTheme } from "../../BookingPage/EditorialBookingPageRoot";
import { useActiveBookingVariant } from "../../BookingPage/activeBookingVariant";
import AppointmentFlowContent from "./AppointmentFlowContent";

const NewAppointmentModal: React.FC = () => {
  const { isAppointmentModalActive, appointmentForm, closeAppointmentForm } =
    useApp();
  const { t } = useLocale();
  // Mounted by the root layout, outside the page's booking root: it takes
  // the skin of the root on screen (a quote link opens the flow here).
  const visualVariant = useActiveBookingVariant();

  const onClose = useCallback(() => {
    closeAppointmentForm();
  }, [closeAppointmentForm]);

  if (!appointmentForm) return null;

  return (
    <BookingOverlayTheme visualVariant={visualVariant}>
      <ResponsiveDialog
        open={isAppointmentModalActive}
        title={t.appointment}
        onClose={onClose}
        className={visualVariant ? "openings-booking-portal" : undefined}
      >
        <AppointmentFlowContent
          // Remount when the selected logical booking changes so its flow state
          // and stable create idempotency key cannot leak into a new attempt.
          key={JSON.stringify([
            appointmentForm.salonId,
            appointmentForm.userId,
            appointmentForm.scheduleId,
            appointmentForm.date,
            appointmentForm.time,
            appointmentForm.requestId ?? null,
            appointmentForm.quotePublicId ?? null,
            appointmentForm.services.map((service) => [
              service.id,
              service.option?.id ?? null,
            ]),
          ])}
          appointmentForm={appointmentForm}
          onClose={onClose}
          completionMode={appointmentForm.completionMode}
        />
      </ResponsiveDialog>
    </BookingOverlayTheme>
  );
};

export default NewAppointmentModal;
